

window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
   .on('shopify:section:load', this._onSectionLoad.bind(this))
   .on('shopify:section:unload', this._onSectionUnload.bind(this))
   .on('shopify:section:select', this._onSelect.bind(this))
   .on('shopify:section:deselect', this._onDeselect.bind(this))
   .on('shopify:block:select', this._onBlockSelect.bind(this))
   .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
   var $container = $(container);
   var id = $container.attr('data-section-id');
   var type = $container.attr('data-section-type');
   

   constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

   var instance = _.assignIn(new constructor(container), {
    id: id,
    type: type,
    container: container
   });

   this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
   var container = $('[data-section-id]', evt.target)[0];
   if (container) {
    this._createInstance(container);
   }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

    if (isEventInstance) {
      if (_.isFunction(instance.onUnload)) {
       instance.onUnload(evt);
      }
    }

    return !isEventInstance;
   });
  },
  _onSelect: function(evt) {
   // eslint-disable-next-line no-shadow
   var instance = _.find(this.instances, function(instance) {
    return instance.id === evt.detail.sectionId;
   });

   if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
    instance.onSelect(evt);
   }
  },

  _onDeselect: function(evt) {
   // eslint-disable-next-line no-shadow
   var instance = _.find(this.instances, function(instance) {
    return instance.id === evt.detail.sectionId;
   });

   if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
    instance.onDeselect(evt);
   }
  },

  _onBlockSelect: function(evt) {
   // eslint-disable-next-line no-shadow
   var instance = _.find(this.instances, function(instance) {
    return instance.id === evt.detail.sectionId;
   });

   if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
    instance.onBlockSelect(evt);
   }
  },

  _onBlockDeselect: function(evt) {
   // eslint-disable-next-line no-shadow
   var instance = _.find(this.instances, function(instance) {
    return instance.id === evt.detail.sectionId;
   });

   if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
    instance.onBlockDeselect(evt);
   }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
   $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
   var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
   var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

   $iframeVideo.each(function() {
    // Add wrapper to make video responsive
    $(this).wrap('<div class="video-wrapper"></div>');
   });

   $iframeReset.each(function() {
    // Re-set the src attribute on each iframe after page load
    // for Chrome's "incorrect iFrame content on 'back'" bug.
    // https://code.google.com/p/chromium/issues/detail?id=395791
    // Need to specifically target video and admin bar
    this.src = this.src;
   });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
  * For use when focus shifts to a container rather than a link
  * eg for In-page links, after scroll, focus shifts to content area so that
  * next `tab` is where user expects if focusing a link, just $link.focus();
  *
  * @param {JQuery} $element - The element to be acted upon
  */
  pageLinkFocus: function($element) {
   var focusClass = 'js-focus-hidden';

   $element.first()
    .attr('tabIndex', '-1')
    .focus()
    .addClass(focusClass)
    .one('blur', callback);

   function callback() {
    $element.first()
      .removeClass(focusClass)
      .removeAttr('tabindex');
   }
  },

  /**
  * If there's a hash in the url, focus the appropriate element
  */
  focusHash: function() {
   var hash = window.location.hash;

   // is there a hash in the url? is it an element on the page?
   if (hash && document.getElementById(hash.slice(1))) {
    this.pageLinkFocus($(hash));
   }
  },

  /**
  * When an in-page (url w/hash) link is clicked, focus the appropriate element
  */
  bindInPageLinks: function() {
   $('a[href*=#]').on('click', function(evt) {
    this.pageLinkFocus($(evt.currentTarget.hash));
   }.bind(this));
  },

  /**
  * Traps the focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  trapFocus: function(options) {
   var eventName = options.eventNamespace
    ? 'focusin.' + options.eventNamespace
    : 'focusin';

   if (!options.$elementToFocus) {
    options.$elementToFocus = options.$container;
   }

   options.$container.attr('tabindex', '-1');
   options.$elementToFocus.focus();

   $(document).on(eventName, function(evt) {
    if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
      options.$container.focus();
    }
   });
  },

  /**
  * Removes the trap of focus in a particular container
  *
  * @param {object} options - Options to be used
  * @param {jQuery} options.$container - Container to trap focus within
  * @param {string} options.namespace - Namespace used for new focus event handler
  */
  removeTrapFocus: function(options) {
   var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';

   if (options.$container && options.$container.length) {
    options.$container.removeAttr('tabindex');
   }

   $(document).off(eventName);
  }
};


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
   var defaults = {
    close: '.js-drawer-close',
    open: '.js-drawer-open-' + position,
    openClass: 'js-drawer-open',
    dirOpenClass: 'js-drawer-open-' + position
   };

   this.nodes = {
    $parent: $('html').add('body'),
    $page: $('#PageContainer')
   };

   this.config = $.extend(defaults, options);
   this.position = position;

   this.$drawer = $('#' + id);

   if (!this.$drawer.length) {
    return false;
   }

   this.drawerIsOpen = false;
   this.init();
  }

  Drawer.prototype.init = function() {
   $(this.config.open).on('click', $.proxy(this.open, this));
   this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
   // Keep track if drawer was opened from a click, or called by another function
   var externalCall = false;

   // Prevent following href if link is clicked
   if (evt) {
    evt.preventDefault();
   } else {
    externalCall = true;
   }

   // Without this, the drawer opens, the click event bubbles up to nodes.$page
   // which closes the drawer.
   if (evt && evt.stopPropagation) {
    evt.stopPropagation();
    // save the source of the click, we'll focus to this on close
    this.$activeSource = $(evt.currentTarget);
   }

   if (this.drawerIsOpen && !externalCall) {
    return this.close();
   }

   // Add is-transitioning class to moved elements on open so drawer can have
   // transition for close animation
   this.$drawer.prepareTransition();

   this.nodes.$parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
   this.drawerIsOpen = true;

   // Set focus on drawer
   slate.a11y.trapFocus({
    $container: this.$drawer,
    namespace: 'drawer_focus'
   });

   // Run function when draw opens if set
   if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
    if (!externalCall) {
      this.config.onDrawerOpen();
    }
   }

   if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
    this.$activeSource.attr('aria-expanded', 'true');
   }

   this.bindEvents();

   return this;
  };

  Drawer.prototype.close = function() {
   if (!this.drawerIsOpen) { // don't close a closed drawer
    return;
   }

   // deselect any focused form elements
   $(document.activeElement).trigger('blur');

   // Ensure closing transition is applied to moved elements, like the nav
   this.$drawer.prepareTransition();

   this.nodes.$parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);

   this.drawerIsOpen = false;

   // Remove focus on drawer
   slate.a11y.trapFocus({
    $container: this.$drawer,
    namespace: 'drawer_focus'
   });

   this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
   this.nodes.$parent.on('keyup.drawer', $.proxy(function(evt) {
    // close on 'esc' keypress
    if (evt.keyCode === 27) {
      this.close();
      return false;
    } else {
      return true;
    }
   }, this));

   // Lock scrolling on mobile
   this.nodes.$page.on('touchmove.drawer', function() {
    return false;
   });

   this.nodes.$page.on('click.drawer', $.proxy(function() {
    this.close();
    return false;
   }, this));
  };

  Drawer.prototype.unbindEvents = function() {
   this.nodes.$page.off('.drawer');
   this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
   body: 'body',
   navigation: '#AccessibleNav',
   siteNavHasDropdown: '.site-nav--has-dropdown',
   siteNavChildLinks: '.site-nav__child-link',
   siteNavActiveDropdown: '.site-nav--active-dropdown',
   siteNavLinkMain: '.site-nav__link--main',
   siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
   activeClass: 'site-nav--active-dropdown',
   childLinkClass: 'site-nav__child-link'
  };

  var cache = {};

  function init() {
   cacheSelectors();

   cache.$parents.on('click.siteNav', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(config.activeClass)) {
      // force stop the click from happening
      evt.preventDefault();
      evt.stopImmediatePropagation();
    }

    showDropdown($el);
   });

   // check when we're leaving a dropdown and close the active dropdown
   $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
    setTimeout(function() {
      if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
       return;
      }

      hideDropdown(cache.$activeDropdown);
    });
   });

   // close dropdowns when on top level nav
   cache.$topLevel.on('focus.siteNav', function() {
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }
   });

   cache.$subMenuLinks.on('click.siteNav', function(evt) {
    // Prevent click on body from firing instead of link
    evt.stopImmediatePropagation();
   });
  }

  function cacheSelectors() {
   cache = {
    $nav: $(selectors.navigation),
    $topLevel: $(selectors.siteNavLinkMain),
    $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
    $subMenuLinks: $(selectors.siteNavChildLinks),
    $activeDropdown: $(selectors.siteNavActiveDropdown)
   };
  }

  function showDropdown($el) {
   $el.addClass(config.activeClass);

   // close open dropdowns
   if (cache.$activeDropdown.length) {
    hideDropdown(cache.$activeDropdown);
   }

   cache.$activeDropdown = $el;

   // set expanded on open dropdown
   $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

   setTimeout(function() {
    $(window).on('keyup.siteNav', function(evt) {
      if (evt.keyCode === 27) {
       hideDropdown($el);
      }
    });

    $(selectors.body).on('click.siteNav', function() {
      hideDropdown($el);
    });
   }, 250);
  }

  function hideDropdown($el) {
   // remove aria on open dropdown
   $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
   $el.removeClass(config.activeClass);

   // reset active dropdown
   cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

   $(selectors.body).off('click.siteNav');
   $(window).off('keyup.siteNav');
  }

  function unload() {
   $(window).off('.siteNav');
   cache.$parents.off('.siteNav');
   cache.$subMenuLinks.off('.siteNav');
   cache.$topLevel.off('.siteNav');
   $(selectors.siteNavChildLink).off('.siteNav');
   $(selectors.body).off('.siteNav');
  }

  return {
   init: init,
   unload: unload
  };
})();

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
   search: '.search',
   searchSubmit: '.search__submit',
   searchInput: '.search__input',

   siteHeader: '.site-header',
   siteHeaderSearchToggle: '.site-header__search-toggle',
   siteHeaderSearch: '.site-header__search',

   searchDrawer: '.search-bar',
   searchDrawerInput: '.search-bar__input',

   searchHeader: '.search-header',
   searchHeaderInput: '.search-header__input',
   searchHeaderSubmit: '.search-header__submit'
  };

  var classes = {
   focus: 'search--focus'
  };

  function init() {
   if (!$(selectors.siteHeader).length) {
    return;
   }

   initDrawer();
   searchSubmit();

   $(selectors.searchHeaderInput).add(selectors.searchHeaderSubmit).on('focus blur', function() {
    $(selectors.searchHeader).toggleClass(classes.focus);
   });

   $(selectors.siteHeaderSearchToggle).on('click', function() {
    var searchHeight = $(selectors.siteHeader).outerHeight();
    var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

    $(selectors.searchDrawer).css({
      height: searchHeight + 'px',
      top: searchOffset + 'px'
    });
   });
  }

  function initDrawer() {
   // Add required classes to HTML
   $('#PageContainer').addClass('drawer-page-content');
   $('.js-drawer-open-top').attr('aria-controls', 'SearchDrawer').attr('aria-expanded', 'false');

   theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {onDrawerOpen: searchDrawerFocus});
  }

  function searchDrawerFocus() {
   searchFocus($(selectors.searchDrawerInput));
  }

  function searchFocus($el) {
   $el.focus();
   // set selection range hack for iOS
   $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchSubmit() {
   $(selectors.searchSubmit).on('click', function(evt) {
    var $el = $(evt.target);
    var $input = $el.parents(selectors.search).find(selectors.searchInput);
    if ($input.val().length === 0) {
      evt.preventDefault();
      searchFocus($input);
    }
   });
  }

  return {
   init: init
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
   mobileNavOpenIcon: 'mobile-nav--open',
   mobileNavCloseIcon: 'mobile-nav--close',
   subNavLink: 'mobile-nav__sublist-link',
   return: 'mobile-nav__return-btn',
   subNavActive: 'is-active',
   subNavClosing: 'is-closing',
   navOpen: 'js-menu--is-open',
   subNavShowing: 'sub-nav--is-open',
   thirdNavShowing: 'third-nav--is-open',
   subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
   cacheSelectors();

   cache.$mobileNavToggle.on('click', toggleMobileNav);
   cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

   // Close mobile nav when unmatching mobile breakpoint
   enquire.register(mediaQuerySmall, {
    unmatch: function() {
      closeMobileNav();
    }
   });
  }

  function toggleMobileNav() {
   if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
    closeMobileNav();
   } else {
    openMobileNav();
   }
  }

  function cacheSelectors() {
   cache = {
    $pageContainer: $('#PageContainer'),
    $siteHeader: $('.site-header'),
    $mobileNavToggle: $('.js-mobile-nav-toggle'),
    $mobileNavContainer: $('.mobile-nav-wrapper'),
    $mobileNav: $('#MobileNav'),
    $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
   };
  }

  function openMobileNav() {
   var translateHeaderHeight = cache.$siteHeader.outerHeight() + cache.$siteHeader.offset().top;

   cache.$mobileNavContainer
    .prepareTransition()
    .addClass(classes.navOpen);

   cache.$mobileNavContainer.css({
    transform: 'translate3d(0, ' + translateHeaderHeight + 'px, 0)'
   });
   cache.$pageContainer.css({
    transform: 'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
   });

   slate.a11y.trapFocus({
    $container: cache.$mobileNav,
    namespace: 'navFocus'
   });

   cache.$mobileNavToggle
    .addClass(classes.mobileNavCloseIcon)
    .removeClass(classes.mobileNavOpenIcon);

   // close on escape
   $(window).on('keyup.mobileNav', function(evt) {
    if (evt.which === 27) {
      closeMobileNav();
    }
   });
  }

  function closeMobileNav() {
   cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

   cache.$mobileNavContainer.css({
    transform: 'translate3d(0, -100%, 0)'
   });
   cache.$pageContainer.removeAttr('style');

   cache.$mobileNavContainer.one('TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle', function() {
    slate.a11y.removeTrapFocus({
      $container: cache.$mobileNav,
      namespace: 'navFocus'
    });
   });

   cache.$mobileNavToggle
    .addClass(classes.mobileNavOpenIcon)
    .removeClass(classes.mobileNavCloseIcon);

   $(window).off('keyup.mobileNav');
  }

  function toggleSubNav(evt) {
   if (isTransitioning) {
    return;
   }

   var $toggleBtn = $(evt.currentTarget);
   var isReturn = $toggleBtn.hasClass(classes.return);
   isTransitioning = true;

   if (isReturn) {
    // Close all subnavs by removing active class on buttons
    $('.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]')
      .removeClass(classes.subNavActive);

    if ($activeTrigger && $activeTrigger.length) {
      $activeTrigger.removeClass(classes.subNavActive);
    }
   } else {
    $toggleBtn.addClass(classes.subNavActive);
   }

   $activeTrigger = $toggleBtn;

   goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {

   /*eslint-disable shopify/jquery-dollar-sign-reference */

   var $targetMenu = target
    ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
    : cache.$mobileNav;

   menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

   if ($activeSubNav && $activeSubNav.length) {
    $activeSubNav
      .prepareTransition()
      .addClass(classes.subNavClosing);
   }

   $activeSubNav = $targetMenu;

   var $elementToFocus = target
    ? $targetMenu.find('.' + classes.subNavLink + ':first')
    : $activeTrigger;

   /*eslint-enable shopify/jquery-dollar-sign-reference */

   var translateMenuHeight = $targetMenu[0].scrollHeight;
   if (!target) {
    translateMenuHeight = $targetMenu.outerHeight();
   }

   var openNavClass = menuLevel > 2
    ? classes.thirdNavShowing
    : classes.subNavShowing;

   cache.$mobileNavContainer
    .css('height', translateMenuHeight)
    .removeClass(classes.thirdNavShowing)
    .addClass(openNavClass);

   if (!target) {
    // Show top level nav
    cache.$mobileNavContainer
      .removeClass(classes.thirdNavShowing)
      .removeClass(classes.subNavShowing);
   }

   // Focusing an item in the subnav early forces element into view and breaks the animation.
   cache.$mobileNavContainer.one('TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle', function() {
    slate.a11y.trapFocus({
      $container: $targetMenu,
      $elementToFocus: $elementToFocus,
      namespace: 'subNavFocus'
    });

    cache.$mobileNavContainer.off('.subnavToggle');
    isTransitioning = false;
   });

   // Match height of subnav
   cache.$pageContainer.css({
    transform: 'translate3d(0, ' + translateMenuHeight + 'px, 0)'
   });

   $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
   init: init
  };
})(jQuery);

(function() {
  var selectors = {
   backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
   return;
  }

  $backButton.one('click', function(evt) {
   evt.preventDefault();

   var referrerDomain = urlDomain(document.referrer);
   var shopDomain = urlDomain(window.location.href);

   if (shopDomain === referrerDomain) {
    history.back();
   }

   return false;
  });

  function urlDomain(url) {
   var anchor = document.createElement('a');
   anchor.ref = url;

   return anchor.hostname;
  }
})();
var checkrtl = false;
var checkfade = true;
if ($("html").hasClass("rtl")) {
  var checkrtl = true;
  var checkfade = false;
}


theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
   wrapper: 'slideshow-wrapper',
   slideshow: 'slideshow',
   currentSlide: 'slick-current',
   video: 'slideshow__video',
   videoBackground: 'slideshow__video--background',
   closeVideoBtn: 'slideshow__video-control--close',
   pauseButton: 'slideshow__pause',
   isPaused: 'is-paused'
  };

  function slideshow(el) {
    if($('.slideshow').data('anima') == 'fade'){
      var checkfade = true;
    }
    else{
      var checkfade = false;
    }
   this.$slideshow = $(el);
   this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
   this.$pause = this.$wrapper.find('.' + classes.pauseButton);

   this.settings = {
    accessibility: true,
    arrows: this.$slideshow.data('arrows'),
    dots: this.$slideshow.data('dots'),
    fade: checkfade,
    draggable: true,
    touchThreshold: 20,
    autoplay: this.$slideshow.data('autoplay'),
    autoplaySpeed: this.$slideshow.data('speed'),
    rtl:checkrtl,
   };

   this.$slideshow.on('beforeChange', beforeChange.bind(this));
   this.$slideshow.on('init', slideshowA11y.bind(this));
   this.$slideshow.slick(this.settings);

   this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
   var $slider = obj.$slider;
   var $list = obj.$list;
   var $wrapper = this.$wrapper;
   var autoplay = this.settings.autoplay;

   // Remove default Slick aria-live attr until slider is focused
   $list.removeAttr('aria-live');

   // When an element in the slider is focused
   // pause slideshow and set aria-live.
   $wrapper.on('focusin', function(evt) {
    if (!$wrapper.has(evt.target).length) {
      return;
    }

    $list.attr('aria-live', 'polite');

    if (autoplay) {
      $slider.slick('slickPause');
    }
   });

   // Resume autoplay
   $wrapper.on('focusout', function(evt) {
    if (!$wrapper.has(evt.target).length) {
      return;
    }

    $list.removeAttr('aria-live');

    if (autoplay) {
      // Manual check if the focused element was the video close button
      // to ensure autoplay does not resume when focus goes inside YouTube iframe
      if ($(evt.target).hasClass(classes.closeVideoBtn)) {
       return;
      }

      $slider.slick('slickPlay');
    }
   });

   // Add arrow key support when focused
   if (obj.$dots) {
    obj.$dots.on('keydown', function(evt) {
      if (evt.which === 37) {
       $slider.slick('slickPrev');
      }

      if (evt.which === 39) {
       $slider.slick('slickNext');
      }

      // Update focus on newly selected tab
      if ((evt.which === 37) || (evt.which === 39)) {
       obj.$dots.find('.slick-active button').focus();
      }
    });
   }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
   var $slider = slick.$slider;
   var $currentSlide = $slider.find('.' + classes.currentSlide);
   var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

   if (isVideoInSlide($currentSlide)) {
    var $currentVideo = $currentSlide.find('.' + classes.video);
    var currentVideoId = $currentVideo.attr('id');
    theme.SlideshowVideo.pauseVideo(currentVideoId);
    $currentVideo.attr('tabindex', '-1');
   }

   if (isVideoInSlide($nextSlide)) {
    var $video = $nextSlide.find('.' + classes.video);
    var videoId = $video.attr('id');
    var isBackground = $video.hasClass(classes.videoBackground);
    if (isBackground) {
      theme.SlideshowVideo.playVideo(videoId);
    } else {
      $video.attr('tabindex', '0');
    }
   }
  }

  function isVideoInSlide($slide) {
   return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
   var slideshowSelector = getSlideshowId(this.$pause);
   if (this.$pause.hasClass(classes.isPaused)) {
    this.$pause.removeClass(classes.isPaused);
    $(slideshowSelector).slick('slickPlay');
   } else {
    this.$pause.addClass(classes.isPaused);
    $(slideshowSelector).slick('slickPause');
   }
  };

  function getSlideshowId($el) {
   return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
   ratio: 16 / 9,
   playerVars: {
    // eslint-disable-next-line camelcase
    iv_load_policy: 3,
    modestbranding: 1,
    autoplay: 0,
    controls: 0,
    showinfo: 0,
    wmode: 'opaque',
    branding: 0,
    autohide: 0,
    rel: 0
   },
   events: {
    onReady: onPlayerReady,
    onStateChange: onPlayerChange
   }
  };
  var classes = {
   playing: 'video-is-playing',
   paused: 'video-is-paused',
   loading: 'video-is-loading',
   loaded: 'video-is-loaded',
   slideshowWrapper: 'slideshow-wrapper',
   slide: 'slideshow__slide',
   slideBackgroundVideo: 'slideshow__slide--background-video',
   slideDots: 'slick-dots',
   videoChrome: 'slideshow__video--chrome',
   videoBackground: 'slideshow__video--background',
   playVideoBtn: 'slideshow__video-control--play',
   closeVideoBtn: 'slideshow__video-control--close',
   currentSlide: 'slick-current',
   slickClone: 'slick-cloned',
   supportsAutoplay: 'autoplay',
   supportsNoAutoplay: 'no-autoplay'
  };

  /**
   * Public functions
  */
  function init($video) {
   if (!$video.length) {
    return;
   }

   videos[$video.attr('id')] = {
    id: $video.attr('id'),
    videoId: $video.data('id'),
    type: $video.data('type'),
    status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
    videoSelector: $video.attr('id'),
    $parentSlide: $video.closest('.' + classes.slide),
    $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
    controls: $video.data('type') === 'background' ? 0 : 1,
    slideshow: $video.data('slideshow')
   };

   if (!youtubeLoaded) {
    // This code loads the IFrame Player API code asynchronously.
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
   }
  }

  function customPlayVideo(playerId) {
   // Do not autoplay just because the slideshow asked you to.
   // If the slideshow asks to play a video, make sure
   // we have done the playOnClick check first
   if (!playOnClickChecked && !playOnClick) {
    return;
   }

   if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
    privatePlayVideo(playerId);
   }
  }

  function pauseVideo(playerId) {
   if (videoPlayers[playerId] && typeof videoPlayers[playerId].pauseVideo === 'function') {
    videoPlayers[playerId].pauseVideo();
   }
  }

  function loadVideos() {
   for (var key in videos) {
    if (videos.hasOwnProperty(key)) {
      var args = $.extend({}, videoOptions, videos[key]);
      args.playerVars.controls = args.controls;
      videoPlayers[key] = new YT.Player(key, args);
    }
   }

   initEvents();
   youtubeLoaded = true;
  }

  function loadVideo(key) {
   if (!youtubeLoaded) {
    return;
   }
   var args = $.extend({}, videoOptions, videos[key]);
   args.playerVars.controls = args.controls;
   videoPlayers[key] = new YT.Player(key, args);

   initEvents();
  }

  /**
   * Private functions
  */

  function privatePlayVideo(id, clicked) {
   var videoData = videos[id];
   var player = videoPlayers[id];
   var $slide = videos[id].$parentSlide;

   if (playOnClick) {
    // playOnClick means we are probably on mobile (no autoplay).
    // setAsPlaying will show the iframe, requiring another click
    // to play the video.
    setAsPlaying(videoData);
   } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
    // Play if autoplay is available or clicked to play
    $slide.removeClass(classes.loading);
    setAsPlaying(videoData);
    player.playVideo();
    return;
   }

   // Check for autoplay if not already done
   if (!autoplayCheckComplete) {
    autoplayCheckFunction(player, $slide);
   }
  }

  function setAutoplaySupport(supported) {
   var supportClass = supported ? classes.supportsAutoplay : classes.supportsNoAutoplay;
   $(document.documentElement).addClass(supportClass);

   if (!supported) {
    playOnClick = true;
   }

   autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
   // attempt to play video
   player.playVideo();

   autoplayTest(player)
    .then(function() {
      setAutoplaySupport(true);
    })
    .fail(function() {
      // No autoplay available (or took too long to start playing).
      // Show fallback image. Stop video for safety.
      setAutoplaySupport(false);
      player.stopVideo();
    })
    .always(function() {
      autoplayCheckComplete = true;
      $slide.removeClass(classes.loading);
    });
  }

  function autoplayTest(player) {
   var deferred = $.Deferred();
   var wait;
   var timeout;

   wait = setInterval(function() {
    if (player.getCurrentTime() <= 0) {
      return;
    }

    autoplayAvailable = true;
    clearInterval(wait);
    clearTimeout(timeout);
    deferred.resolve();
   }, 500);

   timeout = setTimeout(function() {
    clearInterval(wait);
    deferred.reject();
   }, 4000); // subjective. test up to 8 times over 4 seconds

   return deferred;
  }

  function playOnClickCheck() {
   // Bail early for a few instances:
   // - small screen
   // - device sniff mobile browser

   if (playOnClickChecked) {
    return;
   }

   if ($(window).width() < 750) {
    playOnClick = true;
   } else if (window.mobileCheck()) {
    playOnClick = true;
   }

   if (playOnClick) {
    // No need to also do the autoplay check
    setAutoplaySupport(false);
   }

   playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
   evt.target.setPlaybackQuality('hd1080');
   var videoData = getVideoOptions(evt);

   playOnClickCheck();

   // Prevent tabbing through YouTube player controls until visible
   $('#' + videoData.id).attr('tabindex', '-1');

   sizeBackgroundVideos();

   // Customize based on options from the video ID
   switch (videoData.type) {
    case 'background-chrome':
    case 'background':
      evt.target.mute();
      // Only play the video if it is in the active slide
      if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
       privatePlayVideo(videoData.id);
      }
      break;
   }

   videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
   var videoData = getVideoOptions(evt);

   switch (evt.data) {
    case 0: // ended
      setAsFinished(videoData);
      break;
    case 1: // playing
      setAsPlaying(videoData);
      break;
    case 2: // paused
      setAsPaused(videoData);
      break;
   }
  }

  function setAsFinished(videoData) {
   switch (videoData.type) {
    case 'background':
      videoPlayers[videoData.id].seekTo(0);
      break;
    case 'background-chrome':
      videoPlayers[videoData.id].seekTo(0);
      closeVideo(videoData.id);
      break;
    case 'chrome':
      closeVideo(videoData.id);
      break;
   }
  }

  function setAsPlaying(videoData) {
   var $slideshow = videoData.$parentSlideshowWrapper;
   var $slide = videoData.$parentSlide;

   $slide.removeClass(classes.loading);

   // Do not change element visibility if it is a background video
   if (videoData.status === 'background') {
    return;
   }

   $('#' + videoData.id).attr('tabindex', '0');

   switch (videoData.type) {
    case 'chrome':
    case 'background-chrome':
      $slideshow
       .removeClass(classes.paused)
       .addClass(classes.playing);
      $slide
       .removeClass(classes.paused)
       .addClass(classes.playing);
      break;
   }

   // Update focus to the close button so we stay within the slide
   $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
   var $slideshow = videoData.$parentSlideshowWrapper;
   var $slide = videoData.$parentSlide;

   if (videoData.type === 'background-chrome') {
    closeVideo(videoData.id);
    return;
   }

   // YT's events fire after our click event. This status flag ensures
   // we don't interact with a closed or background video.
   if (videoData.status !== 'closed' && videoData.type !== 'background') {
    $slideshow.addClass(classes.paused);
    $slide.addClass(classes.paused);
   }

   if (videoData.type === 'chrome' && videoData.status === 'closed') {
    $slideshow.removeClass(classes.paused);
    $slide.removeClass(classes.paused);
   }

   $slideshow.removeClass(classes.playing);
   $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
   var videoData = videos[playerId];
   var $slideshow = videoData.$parentSlideshowWrapper;
   var $slide = videoData.$parentSlide;
   var classesToRemove = [classes.pause, classes.playing].join(' ');

   $('#' + videoData.id).attr('tabindex', '-1');

   videoData.status = 'closed';

   switch (videoData.type) {
    case 'background-chrome':
      videoPlayers[playerId].mute();
      setBackgroundVideo(playerId);
      break;
    case 'chrome':
      videoPlayers[playerId].stopVideo();
      setAsPaused(videoData); // in case the video is already paused
      break;
   }

   $slideshow.removeClass(classesToRemove);
   $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
   return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
   var videoData = videos[playerId];
   // add loading class to slide
   videoData.$parentSlide.addClass(classes.loading);

   videoData.status = 'open';

   switch (videoData.type) {
    case 'background-chrome':
      unsetBackgroundVideo(playerId, videoData);
      videoPlayers[playerId].unMute();
      privatePlayVideo(playerId, true);
      break;
    case 'chrome':
      privatePlayVideo(playerId, true);
      break;
   }

   // esc to close video player
   $(document).on('keydown.videoPlayer', function(evt) {
    if (evt.keyCode === 27) {
      closeVideo(playerId);
    }
   });
  }

  function sizeBackgroundVideos() {
   $('.' + classes.videoBackground).each(function(index, el) {
    sizeBackgroundVideo($(el));
   });
  }

  function sizeBackgroundVideo($player) {
   var $slide = $player.closest('.' + classes.slide);
   // Ignore cloned slides
   if ($slide.hasClass(classes.slickClone)) {
    return;
   }
   var slideWidth = $slide.width();
   var playerWidth = $player.width();
   var playerHeight = $player.height();

   // when screen aspect ratio differs from video, video must center and underlay one dimension
   if (slideWidth / videoOptions.ratio < playerHeight) {
    playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
    $player.width(playerWidth).height(playerHeight).css({
      left: (slideWidth - playerWidth) / 2,
      top: 0
    }); // player width is greater, offset left; reset top
   } else { // new video width < window width (gap to right)
    playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
    $player.width(slideWidth).height(playerHeight).css({
      left: 0,
      top: (playerHeight - playerHeight) / 2
    }); // player height is greater, offset top; reset left
   }

   $player
    .prepareTransition()
    .addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
   // Switch the background-chrome to a chrome-only player once played
   $('#' + playerId)
    .removeAttr('style')
    .removeClass(classes.videoBackground)
    .addClass(classes.videoChrome);

   videos[playerId].$parentSlideshowWrapper
    .removeClass(classes.slideBackgroundVideo)
    .addClass(classes.playing);

   videos[playerId].$parentSlide
    .removeClass(classes.slideBackgroundVideo)
    .addClass(classes.playing);

   videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
   // Switch back to background-chrome when closed
   var $player = $('#' + playerId)
    .addClass(classes.videoBackground)
    .removeClass(classes.videoChrome);

   videos[playerId].$parentSlide
    .addClass(classes.slideBackgroundVideo);

   videos[playerId].status = 'background';
   sizeBackgroundVideo($player);
  }

  function initEvents() {
   $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(evt) {
    var playerId = $(evt.currentTarget).data('controls');
    startVideoOnClick(playerId);
   });

   $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(evt) {
    var playerId = $(evt.currentTarget).data('controls');
    closeVideo(playerId);
   });

   // Listen to resize to keep a background-size:cover-like layout
   $(window).on('resize.videoPlayer', $.debounce(250, function() {
    if (youtubeLoaded) {
      sizeBackgroundVideos();
    }
   }));
  }

  function removeEvents() {
   $(document).off('.videoPlayer');
   $(window).off('.videoPlayer');
  }

  return {
   init: init,
   loadVideos: loadVideos,
   loadVideo: loadVideo,
   playVideo: customPlayVideo,
   pauseVideo: pauseVideo,
   removeEvents: removeEvents
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
   return;
  }

  $filterBy.on('change', function() {
   location.href = $(this).val();
  });

})();

window.theme = theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
   // Show reset password form
   $('#RecoverPassword').on('click', function(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
   });

   // Hide reset password form
   $('#HideRecoverPasswordLink').on('click', function(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
   });
  }

  /**
  *
  *  Show/Hide recover password form
  *
  */
  function toggleRecoverPasswordForm() {
   $('#RecoverPasswordForm').toggleClass('hide');
   $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
  *
  *  Show reset password success message
  *
  */
  function resetPasswordSuccess() {
   var $formState = $('.reset-password-success');

   // check if reset password form was successfully submited.
   if (!$formState.length) {
    return;
   }

   // show success message
   $('#ResetSuccess').removeClass('hide');
  }

  /**
  *
  *  Show/hide customer address forms
  *
  */
  function customerAddressForm() {
   var $newAddressForm = $('#AddressNewForm');

   if (!$newAddressForm.length) {
    return;
   }

   // Initialize observers on address selectors, defined in shopify_common.js
   if (Shopify) {
    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
   }

   // Initialize each edit form's country/province selector
   $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    // eslint-disable-next-line no-new
    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
   });

   // Toggle new/edit address forms
   $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
   });

   $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
   });

   $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');

    // eslint-disable-next-line no-alert
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
   });
  }

  /**
  *
  *  Check URL for reset password hash
  *
  */
  function checkUrlHash() {
   var hash = window.location.hash;

   // Allow deep linking to recover password form
   if (hash === '#recover') {
    toggleRecoverPasswordForm();
   }
  }

  return {
   init: function() {
    checkUrlHash();
    initEventListeners();
    resetPasswordSuccess();
    customerAddressForm();
   }
  };
})();




/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
   edit: '.js-edit-toggle'
  };
  var config = {
   showClass: 'cart__update--show',
   showEditClass: 'cart__edit--active'
  };

  function Cart(container) {
   this.$container = $(container);
   this.$edit = $(selectors.edit, this.$container);

   this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
   onUnload: function() {
    this.$edit.off('click', this._onEditClick);
   },

   _onEditClick: function(evt) {
    var $evtTarget = $(evt.target);
    var $updateLine = $('.' + $evtTarget.data('target'));

    $evtTarget.toggleClass(config.showEditClass);
    $updateLine.toggleClass(config.showClass);
   }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var constants = {
   SORT_BY: 'sort_by',
   DEFAULT_SORT: 'title-ascending'
  };
  var selectors = {
   filterSelection: '.filters-toolbar__input--filter',
   sortSelection: '.filters-toolbar__input--sort',
   defaultSort: '.filters-toolbar__default-sort'
  };

  function Filters(container) {
   var $container = this.$container = $(container);

   this.$filterSelect = $(selectors.filterSelection, $container);
   this.$sortSelect = $(selectors.sortSelection, $container);
   this.$selects = $(selectors.filterSelection, $container).add($(selectors.sortSelection, $container));

   this.defaultSort = this._getDefaultSortValue();
   this._resizeSelect(this.$selects);
   this.$selects.removeClass('hidden');

   this.$filterSelect.on('change', this._onFilterChange.bind(this));
   this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
   _onSortChange: function(evt) {
    var query = '';

    this.sort = this._getSortValue();

    if (this.sort !== this.defaultSort) {
      query = [constants.SORT_BY + '=' + this.sort];
    }

    var search = document.location.search = query.length ? '?' + query : '';

    document.location.href = this.$filterSelect.val() + search;
    this._resizeSelect($(evt.target));
   },

   _onFilterChange: function(evt) {
    document.location.href = this.$filterSelect.val() + document.location.search;
    this._resizeSelect($(evt.target));
   },

   _getSortValue: function() {
    return this.$sortSelect.val() || this.defaultSort;
   },

   _getDefaultSortValue: function() {
    return $(selectors.defaultSort, this.$container).val() || constants.DEFAULT_SORT;
   },

   _resizeSelect: function($selection) {
    $selection.each(function() {
      var $this = $(this);
      var arrowWidth = 10;
      // create test element
      var text = $this.find('option:selected').text();
      var $test = $('<span>').html(text);

      // add to body, get width, and get out
      $test.appendTo('body');
      var width = $test.width();
      $test.remove();

      // set select width
      $this.width(width + arrowWidth);
    });
   },

   onUnload: function() {
    this.$filterSelect.off('change', this._onFilterChange);
    this.$sortSelect.off('change', this._onSortChange);
   }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {

  function Header() {
   theme.Header.init();
   theme.MobileNav.init();
   theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
   onUnload: function() {
    theme.Header.unload();
   }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
   zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var key = theme.mapKey ? theme.mapKey : '';

  function Map(container) {
   this.$container = $(container);

   if (apiStatus === 'loaded') {
    this.createMap();
   } else {
    mapsToLoad.push(this);

    if (apiStatus !== 'loading') {
      apiStatus = 'loading';
      if (typeof window.google === 'undefined') {
       $.getScript('https://maps.googleapis.com/maps/api/js?key=' + key)
        .then(function() {
          apiStatus = 'loaded';
          initAllMaps();
        });
      }
    }
   }
  }

  function initAllMaps() {
   // API has loaded, load all Map instances in queue
   $.each(mapsToLoad, function(index, instance) {
    instance.createMap();
   });
  }

  function geolocate($map) {
   var deferred = $.Deferred();
   var geocoder = new google.maps.Geocoder();
   var address = $map.data('address-setting');

   geocoder.geocode({address: address}, function(results, status) {
    if (status !== google.maps.GeocoderStatus.OK) {
      deferred.reject(status);
    }

    deferred.resolve(results);
   });

   return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
   createMap: function() {
    var $map = this.$container.find('.map-section__container');

    return geolocate($map)
      .then(function(results) {
       var mapOptions = {
        zoom: config.zoom,
        center: results[0].geometry.location,
        disableDefaultUI: true
       };

       var map = this.map = new google.maps.Map($map[0], mapOptions);
       var center = this.center = map.getCenter();

       //eslint-disable-next-line no-unused-vars
       var marker = new google.maps.Marker({
        map: map,
        position: map.getCenter()
       });

       google.maps.event.addDomListener(window, 'resize', $.debounce(250, function() {
        google.maps.event.trigger(map, 'resize');
        map.setCenter(center);
       }));
      }.bind(this))
      .fail(function() {
       var errorMessage;

       switch (status) {
        case 'ZERO_RESULTS':
          errorMessage = theme.strings.addressNoResults;
          break;
        case 'OVER_QUERY_LIMIT':
          errorMessage = theme.strings.addressQueryLimit;
          break;
        default:
          errorMessage = theme.strings.addressError;
          break;
       }

       $map
        .parent()
        .addClass('page-width map-section--load-error')
        .html('<div class="errors text-center">' + errorMessage + '</div>');
      });
   },

   onUnload: function() {
    google.maps.event.clearListeners(this.map, 'resize');
   }
  });

  return Map;
})();

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars
function gm_authFailure() {
  $('.map-section').addClass('map-section--load-error');
  $('.map-section__container').remove();
  $('.map-section__link').remove();
  $('.map-section__overlay').after('<div class="errors text-center">' + theme.strings.authError + '</div>');
}

/* eslint-disable no-new */
theme.Product = (function() {
  var defaults = {
   // Breakpoints from src/stylesheets/global/variables.scss.liquid
   mediaQuerySmall: 'screen and (max-width: 1920px)',
   bpSmall: false,
   sliderActive: false,
   zoomEnabled: false,
   imageSize: null,
   imageZoomSize: null,
   selectors: {
    addToCart: '#AddToCart',
    productPrice: '#ProductPrice',
    comparePrice: '#ComparePrice',
    addToCartText: '#AddToCartText',
    productFeaturedImage: '#FeaturedImage',
    productThumbImages: '.product-single__thumbnail',
    productThumbs: '.product-single__thumbnails',
    optionSelector: 'productSelect',
    saleLabel: '.product-price__sale-label',
    saleClasses: 'product-price__sale product-price__sale--single'
   }
  };

  function enableZoom($el) {
   var zoomUrl = $el.data('zoom');
   $el.zoom({
    url: zoomUrl
   });
  }

  function destroyZoom($el) {
   $el.trigger('zoom.destroy');
  }

  function Product(container) {
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');

   this.settings = $.extend({}, defaults, {
    sectionId: sectionId,
    enableHistoryState: $container.data('enable-history-state'),
    selectors: {
      originalSelectorId: 'productSelect-' + sectionId,
      addToCart: '#AddToCart-' + sectionId,
      productPrice: '#ProductPrice-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      productFeaturedImage: '#FeaturedImage-' + sectionId,
      productImageWrap: '#FeaturedImageZoom-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleLabel: '.product-price__sale-label-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      price: '.product-price__price-' + sectionId
    }
   });

   // Stop parsing if we don't have the product json script tag when loading
   // section in the Theme Editor
   if (!$('#ProductJson-' + sectionId).html()) {
    return;
   }

   this.productSingleObject = JSON.parse(document.getElementById('ProductJson-' + sectionId).innerHTML);

   this.settings.zoomEnabled = $(this.settings.selectors.productFeaturedImage).hasClass('js-zoom-enabled');
   this.settings.imageSize = Shopify.Image.imageSize($(this.settings.selectors.productFeaturedImage).attr('src'));

   if (this.settings.zoomEnabled) {
    this.settings.imageZoomSize = Shopify.Image.imageSize($(this.settings.selectors.productImageWrap).data('zoom'));
   }

   this.init();

   // Pre-loading product images to avoid a lag when a thumbnail is clicked, or
   // when a variant is selected that has a variant image
   Shopify.Image.preload(this.productSingleObject.images, this.settings.imageSize);
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
   init: function() {
    this.initBreakpoints();
    this.stringOverrides();
    this.initProductVariant();
    this.initProductImageSwitch();
    this.setActiveThumbnail();
   },

   stringOverrides: function() {
    // Override defaults in theme.strings with potential
    // template overrides

    theme.productStrings = theme.productStrings || {};
    $.extend(theme.strings, theme.productStrings);
   },

   initBreakpoints: function() {
    var self = this;
    enquire.register(this.settings.mediaQuerySmall, {
      match: function() {
       // initialize thumbnail slider on mobile if more than three thumbnails
       if ($(self.settings.selectors.productThumbImages).length > 3) {
        self.initProductThumbnailSlider();
       }

       // destroy an image zooming that's enabled
       if (self.settings.zoomEnabled) {
        destroyZoom($(self.settings.selectors.productImageWrap));
       }

       self.settings.bpSmall = true;
      },
      unmatch: function() {
       if (self.settings.sliderActive) {
        self.destroyProductThumbnailSlider();
       }

       if (self.settings.zoomEnabled) {
        enableZoom($(self.settings.selectors.productImageWrap));
       }

       self.settings.bpSmall = false;
      }
     });
   },

   initProductVariant: function() {
    // this.productSingleObject is a global JSON object defined in theme.liquid
    if (!this.productSingleObject) {
      return;
    }

    var self = this;

    this.optionSelector = new Shopify.OptionSelectors(self.settings.selectors.originalSelectorId, {
      selectorClass: self.settings.selectors.optionSelectorClass,
      product: self.productSingleObject,
      onVariantSelected: self.productVariantCallback,
      enableHistoryState: self.settings.enableHistoryState,
      settings: self.settings,
      switchProductImage: self.switchProductImage,
      setActiveThumbnail: self.setActiveThumbnail
    });

    // Clean up variant labels if the Shopify-defined
    // defaults are the only ones left
    this.simplifyVariantLabels(this.productSingleObject);
    this.productVariantStyles();
   },

   simplifyVariantLabels: function(productObject) {
    // Hide variant dropdown if only one exists and title contains 'Default'
    if (productObject.variants.length && productObject.variants[0].title.indexOf('Default') >= 0) {
      $('.selector-wrapper').hide();
    }
   },

   initProductImageSwitch: function() {
    if (!$(this.settings.selectors.productThumbImages).length) {
      return;
    }

    var self = this;

    $(this.settings.selectors.productThumbImages).on('click', function(evt) {
      evt.preventDefault();
      var $el = $(this);
      var imageSrc = $el.attr('href');
      var zoomSrc = $el.data('zoom');

      self.switchProductImage(imageSrc, zoomSrc);
      self.setActiveThumbnail(imageSrc);
    });
   },

   setActiveThumbnail: function(src) {
    var activeClass = 'active-thumb';

    // If there is no element passed, find it by the current product image
    if (typeof src === 'undefined') {
      src = $(this.settings.selectors.productFeaturedImage).attr('src');
    }

    // select all thumbnails (incl. slick cloned thumbs) with matching 'href'
    var $thumbnail = $(this.settings.selectors.productThumbImages + '[href="' + src + '"]');
    // Set active thumbnail classes
    $(this.settings.selectors.productThumbImages).removeClass(activeClass);
    $thumbnail.addClass(activeClass);
   },

   switchProductImage: function(image, zoomImage) {
    $(this.settings.selectors.productFeaturedImage).attr('src', image);

    // destroy any image zooming that might be enabled
    if (this.settings.zoomEnabled) {
      destroyZoom($(this.settings.selectors.productImageWrap));
    }

    if (!this.settings.bpSmall && this.settings.zoomEnabled && zoomImage) {
      $(this.settings.selectors.productImageWrap).data('zoom', zoomImage);
      enableZoom($(this.settings.selectors.productImageWrap));
    }
   },

   initProductThumbnailSlider: function() {
    var options = {
      slidesToShow: 4,
      slidesToScroll: 4,
      infinite: true,
      rtl:checkrtl,
      prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
      nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
      responsive: [
       {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
       }
      ]
    };
    $(this.settings.selectors.productThumbs).slick(options);
    this.settings.sliderActive = true;
    
   },

   destroyProductThumbnailSlider: function() {
    $(this.settings.selectors.productThumbs).slick('unslick');
    this.settings.sliderActive = false;
   },

   productVariantStyles: function() {
    $('.selector-wrapper').addClass('product-form__item');
    $('.single-option-selector').addClass('product-form__input');
   },

   // **WARNING** This function actually inherits `this` from `this.optionSelector` not
   // from `product` when passed in as a callback for `option_selection.js`
   productVariantCallback: function(variant) {
    var sizedImgUrl;
    var zoomSizedImgUrl;

    if (variant) {
      // Update variant image, if one is set
      if (variant.featured_image) {
       sizedImgUrl = Shopify.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
       if (this.settings.zoomEnabled) {
        zoomSizedImgUrl = Shopify.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
       }
       this.switchProductImage(sizedImgUrl, zoomSizedImgUrl);
       this.setActiveThumbnail(sizedImgUrl);
      } else {
       // No featured image so setup the zoom on the images loaded by liquid
       var self = this;
       enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
           enableZoom($(self.settings.selectors.productImageWrap));
          }
        }
       });
      }

      // Update the product price
      $(this.settings.selectors.productPrice).html(Shopify.formatMoney(variant.price, theme.moneyFormat));

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
       $(this.settings.selectors.comparePrice)
        .html(Shopify.formatMoney(variant.compare_at_price, theme.moneyFormat))
        .removeClass('hide');

       $(this.settings.selectors.price).addClass(this.settings.selectors.saleClasses);

       $(this.settings.selectors.saleLabel).removeClass('hide');
      } else {
       $(this.settings.selectors.comparePrice).addClass('hide');
       $(this.settings.selectors.saleLabel).addClass('hide');
       $(this.settings.selectors.price).removeClass(this.settings.selectors.saleClasses);
      }

      // Select a valid variant if available
      if (variant.available) {
       // We have a valid product variant, so enable the submit button
       $(this.settings.selectors.addToCart).prop('disabled', false);
       $(this.settings.selectors.addToCartText).text(theme.strings.addToCart);
      } else {
       // Variant is sold out, disable the submit button and change the text
       $(this.settings.selectors.addToCart).prop('disabled', true);
       $(this.settings.selectors.addToCartText).text(theme.strings.soldOut);
      }
    } else {
      // The variant doesn't exist, disable submit button and change the text.
      // This may be an error or notice that a specific variant is not available.
      $(this.settings.selectors.addToCart).prop('disabled', true);
      $(this.settings.selectors.addToCartText).text(theme.strings.unavailable);
    }
   }

  });

  return Product;
})();



theme.Quotes = (function() {

  var config = {
   mediaQuerySmall: 'screen and (max-width: 749px)',
   mediaQueryMediumUp: 'screen and (min-width: 750px)',
   slideCount: 0,
   slidecol:1,
  };
  var defaults = {
   accessibility: true,
   arrows: false,
   dots: true,
   autoplay: false,
   touchThreshold: 20,
   slidesToShow: 1,
   slidesToScroll: 1,
   rtl:checkrtl,
   responsive: [
    {
      breakpoint: 992,
      settings: {
       autoplay: false,
       adaptiveHeight: true
      }
    }
   ]
  };

  function Quotes(container) {
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');
   var wrapper = this.wrapper = '.quotes-wrapper';
   var slider = this.slider = '#Quotes-' + sectionId;
   var $slider = $(slider, wrapper);
   var sliderActive = false;
   var mobileOptions = $.extend({}, defaults, {
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true
   });

   config.slideCount = $slider.data('count');
   // Override slidesToShow/Scroll if there are not enough blocks
   if (config.slideCount < defaults.slidesToShow) {
    defaults.slidesToShow = config.slideCount;
    defaults.slidesToScroll = config.slideCount;
   }

   $slider.on('init', this.a11y.bind(this));

   enquire.register(config.mediaQuerySmall, {
    match: function() {
      initSlider($slider, mobileOptions);
    }
   });

   enquire.register(config.mediaQueryMediumUp, {
    match: function() {
      initSlider($slider, defaults);
    }
   });

   function initSlider(sliderObj, args) {
    if (sliderActive) {
      sliderObj.slick('unslick');
      sliderActive = false;
    }

    sliderObj.slick(args);
    sliderActive = true;
   }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
   onUnload: function() {
    enquire.unregister(config.mediaQuerySmall);
    enquire.unregister(config.mediaQueryMediumUp);

    $(this.slider, this.wrapper).slick('unslick');
   },

   onBlockSelect: function(evt) {
    // Ignore the cloned version
    var $slide = $('.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
   },

   a11y: function(event, obj) {
    var $list = obj.$list;
    var $wrapper = $(this.wrapper, this.$container);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused set aria-live
    $wrapper.on('focusin', function(evt) {
      if ($wrapper.has(evt.target).length) {
       $list.attr('aria-live', 'polite');
      }
    });

    // Remove aria-live
    $wrapper.on('focusout', function(evt) {
      if ($wrapper.has(evt.target).length) {
       $list.removeAttr('aria-live');
      }
    });
   }
  });

  return Quotes;
})();

//lookbook 
theme.Look = (function() {

  var config = {
      mediaQuerySmall: 'screen and (max-width: 749px)',
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQueryLargeDesk: 'screen and (min-width: 1200px)',
      slideCount: 0,
      slidecol:1,
  };

  function Look(container) {
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');
   var wrapper = this.wrapper = '.look-wrapper';
   var slider = this.slider = '#look-' + sectionId;
   var $slider = $(slider, wrapper);
   var sliderActive = false;
   var defaults = {
        centerMode: true,
        infinite: true,
        centerPadding: '20%',
        slidesToShow: 1,
        speed: 500,
        variableWidth: false,
    };
   var mobileOptions = $.extend({}, defaults, {
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    adaptiveHeight: true,
    centerMode: false,
   });

   config.slideCount = $slider.data('count');
   // Override slidesToShow/Scroll if there are not enough blocks
   if (config.slideCount < defaults.slidesToShow) {
    defaults.slidesToShow = config.slideCount;
    defaults.slidesToScroll = config.slideCount;
   }

   $slider.on('init', this.a11y.bind(this));

   enquire.register(config.mediaQuerySmall, {
    match: function() {
      initSlider($slider, mobileOptions);
    }
   });

   enquire.register(config.mediaQueryMediumUp, {
    match: function() {
      initSlider($slider, defaults);
    }
   });

   function initSlider(sliderObj, args) {
    if (sliderActive) {
      sliderObj.slick('unslick');
      sliderActive = false;
    }

    sliderObj.slick(args);
    sliderActive = true;
   }
  }

  Look.prototype = _.assignIn({}, Look.prototype, {
   onUnload: function() {
    enquire.unregister(config.mediaQuerySmall);
    enquire.unregister(config.mediaQueryMediumUp);

    $(this.slider, this.wrapper).slick('unslick');
   },

   onBlockSelect: function(evt) {
    // Ignore the cloned version
    var $slide = $('.look__b' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
   },

   a11y: function(event, obj) {
    var $list = obj.$list;
    var $wrapper = $(this.wrapper, this.$container);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused set aria-live
    $wrapper.on('focusin', function(evt) {
      if ($wrapper.has(evt.target).length) {
       $list.attr('aria-live', 'polite');
      }
    });

    // Remove aria-live
    $wrapper.on('focusout', function(evt) {
      if ($wrapper.has(evt.target).length) {
       $list.removeAttr('aria-live');
      }
    });
   }
  });

  return Look;
})();

//lookbook 
theme.Lookhome = (function() {

  var config = {
      mediaQuerySmall: 'screen and (max-width: 749px)',
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      slideCount: 0,
      slidecol:1,
  };
  

  function Lookhome(container) {
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');
   var wrapper = this.wrapper = '.lookhome-wrapper';
   var slider = this.slider = '#Lookhome-' + sectionId;
   var $slider = $(slider, wrapper);
   var cols = $slider.data('col');
   var arrows =     $slider.data('arrows');
   var dot =        $slider.data('dot');
   var sliderActive = false;
   var defaults = {
      infinite: false,
      slidesToShow: cols,
       arrows: arrows,
      dots: dot,
   };
   var mobileOptions = $.extend({}, defaults, {
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    centerMode: false,
   });

   config.slideCount = $slider.data('col');
   // Override slidesToShow/Scroll if there are not enough blocks
   if (config.slideCount < defaults.slidesToShow) {
    defaults.slidesToShow = config.slideCount;
    defaults.slidesToScroll = config.slideCount;
   }

   $slider.on('init', this.a11y.bind(this));

   enquire.register(config.mediaQuerySmall, {
    match: function() {
      initSlider($slider, mobileOptions);
    }
   });

   enquire.register(config.mediaQueryMediumUp, {
    match: function() {
      initSlider($slider, defaults);
    }
   });

   function initSlider(sliderObj, args) {
    if (sliderActive) {
      sliderObj.slick('unslick');
      sliderActive = false;
    }

    sliderObj.slick(args);
    sliderActive = true;
   }
  }

  Lookhome.prototype = _.assignIn({}, Lookhome.prototype, {
   onUnload: function() {
    enquire.unregister(config.mediaQuerySmall);
    enquire.unregister(config.mediaQueryMediumUp);

    $(this.slider, this.wrapper).slick('unslick');
   },

   onBlockSelect: function(evt) {
    // Ignore the cloned version
    var $slide = $('.look__h' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
   },

   a11y: function(event, obj) {
    var $list = obj.$list;
    var $wrapper = $(this.wrapper, this.$container);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused set aria-live
    $wrapper.on('focusin', function(evt) {
      if ($wrapper.has(evt.target).length) {
       $list.attr('aria-live', 'polite');
      }
    });

    // Remove aria-live
    $wrapper.on('focusout', function(evt) {
      if ($wrapper.has(evt.target).length) {
       $list.removeAttr('aria-live');
      }
    });
   }
  });

  return Lookhome;
})();

//lookbook 2
theme.Look2 = (function() {
  function Look2(container){
      var $container = this.$container = $(container);
      var sectionId = $container.attr('data-section-id');
       
       var doAnimations = function() {
         // Calc current offset and get all animatables
         var offset = $(window).scrollTop() + $(window).height(),
            $animatables = $('.revealedBox');
            console.log(offset);
         // Unbind scroll handler if we have no animatables
         if ($animatables.size() == 0) {
            $(window).off('scroll', doAnimations);
         }
         // Check all animatables and animate them if necessary
         $animatables.each(function(i) {
            var $animatable = $(this);
            if (($animatable.offset().top + $animatable.height() - 20) < offset) {
               $animatable.addClass('revealedBox-in');
               console.log($animatable.offset().top + $animatable.height() - 20);
            }
         });
      };
      $("#lookver  .look-image").hide();
      size_li = $("#lookver  .look-image").size();
       x=5;
       $('#lookver .look-image:lt('+x+')').show();
       $('#loadMore').click(function () {
           x= (x+5 <= size_li) ? x+5 : size_li;
           $('#lookver .look-image:lt('+x+')').show();
            $('#showLess').css('display','inline-block'); 
           if(x == size_li){
               $('#loadMore').css('display','none');
           }
       });
       $('#showLess').click(function () {
           x=(x-5<0) ? 5 : x-5;
           $('#lookver .look-image').not(':lt('+x+')').hide();
           $('#loadMore').css('display','inline-block');
           $('#showLess').css('display','inline-block');
           if(x == 5){
               $('#showLess').css('display','none');
           }
       });
       // Hook doAnimations on scroll, and trigger a scroll
      $(window).on('scroll', doAnimations);
      $(window).trigger('scroll');     
  }
  return Look2;
})();

//List collection icon 3 
theme.List = (function() {

  var config = {
      mediaQuerySmall: 'screen and (max-width: 749px)',
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      slideCount: 0,
      slidecol:1,
  };
  

  function List(container) {
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');
   var wrapper = this.wrapper = '.list-wrapper';
   var slider = this.slider = '#list-' + sectionId;
   var $slider = $(slider, wrapper);
   var cols = $slider.data('count');
   var rows = $slider.data('row');
   var dot = $slider.data('dot');
   var nav = $slider.data('nav');
   var sliderActive = false;
   var defaults = {
      infinite: false,
      slidesToShow: cols,
      rows: rows,
      dots: dot,
      arrows:nav,
      speed: 500,
      variableWidth: false,
      adaptiveHeight: true,
      responsive: [
      {
        breakpoint: 1199,
        settings: {
         slidesToShow: 4,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
     ]
  };
   var mobileOptions = $.extend({}, defaults, {
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    centerMode: false,
   });

   config.slideCount = $slider.data('count');
   // Override slidesToShow/Scroll if there are not enough blocks
   if (config.slideCount < defaults.slidesToShow) {
    defaults.slidesToShow = config.slideCount;
    defaults.slidesToScroll = config.slideCount;
   }

   $slider.on('init', this.a11y.bind(this));

   enquire.register(config.mediaQuerySmall, {
    match: function() {
      initSlider($slider, mobileOptions);
    }
   });

   enquire.register(config.mediaQueryMediumUp, {
    match: function() {
      initSlider($slider, defaults);
    }
   });

   function initSlider(sliderObj, args) {
    if (sliderActive) {
      sliderObj.slick('unslick');
      sliderActive = false;
    }

    sliderObj.slick(args);
    sliderActive = true;
   }
  }

  List.prototype = _.assignIn({}, List.prototype, {
   onUnload: function() {
    enquire.unregister(config.mediaQuerySmall);
    enquire.unregister(config.mediaQueryMediumUp);

    $(this.slider, this.wrapper).slick('unslick');
   },

   onBlockSelect: function(evt) {
    // Ignore the cloned version
    var $slide = $('.list__b' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
   },

   a11y: function(event, obj) {
    var $list = obj.$list;
    var $wrapper = $(this.wrapper, this.$container);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused set aria-live
    $wrapper.on('focusin', function(evt) {
      if ($wrapper.has(evt.target).length) {
       $list.attr('aria-live', 'polite');
      }
    });

    // Remove aria-live
    $wrapper.on('focusout', function(evt) {
      if ($wrapper.has(evt.target).length) {
       $list.removeAttr('aria-live');
      }
    });
   }
  });

  return List;
})();

//blog
  
  theme.Blogs = (function() {
  var config = {
   mediaQuerySmall: 'screen and (max-width: 767px)',
   mediaQueryMediumUp: '(min-width: 768px) and (max-width: 991px)',
   mediaQueryDesk: 'screen and (min-width: 992px)',
   slideCount: 0
  };
  function Blogs(container) {
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');
   var wrapper = this.wrapper = '.blogs-wrapper';
   var slider = this.slider = '#Blogs-' + sectionId;
   var $slider = $(slider, wrapper);
   var sliderActive = false;
   var blog_per_page = $('.js-blogcolumn').data('blogcolumn');
   var blog_arrows = $('.js-blogcolumn').data('arrows');
   var blog_dot = $('.js-blogcolumn').data('dot');
   var blog_rows = $('.js-blogcolumn').data('rows');
   var defaults = {
     accessibility: true,
     arrows: blog_arrows,
     dots: blog_dot,
     rows: blog_rows,
     autoplay: false,
     touchThreshold: 20,
     slidesToShow: blog_per_page,
     slidesToScroll: 1,
     rtl:checkrtl,
    };
   var mobileOptions = $.extend({}, defaults, {
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: false,

   });
   var tableOptions = $.extend({}, defaults, {
    slidesToShow: 2,
    slidesToScroll: 1,
    adaptiveHeight: true,
    autoplay: false,

   });
   
   config.slideCount = $slider.data('count');

   // Override slidesToShow/Scroll if there are not enough blocks
   if (config.slideCount < defaults.slidesToShow) {
    defaults.slidesToShow = config.slideCount;
    defaults.slidesToScroll = config.slideCount;
   }

   $slider.on('init', this.a11y.bind(this));

   enquire.register(config.mediaQuerySmall, {
    match: function() {
      initSlider($slider, mobileOptions);
    }
   });
    enquire.register(config.mediaQueryMediumUp, {
    match: function() {
      initSlider($slider, tableOptions);
    }
   });

   enquire.register(config.mediaQueryDesk, {
    match: function() {
      initSlider($slider, defaults);
    }
   });

   function initSlider(sliderObj, args) {
    if (sliderActive) {
      sliderObj.slick('unslick');
      sliderActive = false;
    }

    sliderObj.slick(args);
    sliderActive = true;
   }
  }

  Blogs.prototype = _.assignIn({}, Blogs.prototype, {
   onUnload: function() {
    enquire.unregister(config.mediaQuerySmall);
    enquire.unregister(config.mediaQueryMediumUp);
    enquire.unregister(config.mediaQueryDesk);

    $(this.slider, this.wrapper).slick('unslick');
   },

   onBlockSelect: function(evt) {
    // Ignore the cloned version
    var $slide = $('.blogs-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
    var slideIndex = $slide.data('slick-index');

    // Go to selected slide, pause autoplay
    $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
   },

   a11y: function(event, obj) {
    var $list = obj.$list;
    var $wrapper = $(this.wrapper, this.$container);

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused set aria-live
    $wrapper.on('focusin', function(evt) {
      if ($wrapper.has(evt.target).length) {
       $list.attr('aria-live', 'polite');
      }
    });

    // Remove aria-live
    $wrapper.on('focusout', function(evt) {
      if ($wrapper.has(evt.target).length) {
       $list.removeAttr('aria-live');
      }
    });
   }
  });

  return Blogs;
})();

//slick Product list
theme.Productlists = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: '(min-width: 750px) and (max-width: 991px)',
    mediaQueryLarge: '(min-width: 992px) and (max-width: 1199px)',
    mediaQueryLargeDesk: 'screen and (min-width: 1200px)',
    slideShow: 0,
    scrollShow: 0,
    rowNumber: 0
  };
  var defaults = {
    accessibility: true,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 4,
    slidesToScroll: 4,
    rtl: checkrtl  
  };

  function Productlists(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.productlists-wrapper');
    var slider = (this.slider = '#Productlists-' + sectionId);
    var $slider = $(slider, wrapper);
    var x =  (this.x = '#poructs2-' + sectionId);
    var y = (this.y = '.col-flex');
    var u = (this.u = '.column-products');
    var $z = $(y,x);
    var $t = $(u,x);

    config.slideShow = parseInt($slider.attr('data-toshow'));
    config.scrollShow = parseInt($slider.attr('data-scroll'));
    config.rowNumber = parseInt($slider.attr('data-row'));
    var play =       $slider.data('play');
    var checkplay =  $slider.data('autoplay');
    var arrows =     $slider.data('arrows');
    var dot =        $slider.data('dot');
    var laptop =     $slider.data('laptop');
    var table =     $slider.data('table');
    var phonemin =     $slider.data('phonemin');
    
    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      arrows: arrows,
      dots:dot,
      slidesToShow: phonemin,
      slidesToScroll: phonemin,
      adaptiveHeight: true
    });
    var tableOptions = $.extend({}, defaults, {
      arrows: arrows,
      dots:dot,
      slidesToShow: table,
      slidesToScroll: table,
      adaptiveHeight: true
    });
    var desktopOptions = $.extend({}, defaults, {
      arrows: arrows,
      dots:dot,
      slidesToShow: laptop,
      slidesToScroll: laptop,
      adaptiveHeight: true
    });
    var desktopOptionsDesk = $.extend({}, defaults, {
      arrows: arrows,
      dots:dot,
      slidesToShow: config.slideShow,
      slidesToScroll: config.scrollShow,
      rows: config.rowNumber,
      adaptiveHeight: true,
      autoplay: checkplay,
      autoplaySpeed: play
    });

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });
    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, tableOptions);
      }
    });
    enquire.register(config.mediaQueryLarge, {
      match: function() {
        initSlider($slider, desktopOptions);
      }
    });
    enquire.register(config.mediaQueryLargeDesk, {
      match: function() {
        initSlider($slider, desktopOptionsDesk);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
    /*heightbanner();
    var resizeTimer;
    $(window).on('resize', function(e) {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        heightbanner();
      }, 250);
    });
    function heightbanner(){
      var height_x = $t.outerHeight(true);
      $z.css('height', height_x);
      //$t.css('height', height_x);
    }*/
  }

  Productlists.prototype = _.assignIn({}, Productlists.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);
    enquire.unregister(config.mediaQueryLarge);
    enquire.unregister(config.mediaQueryLargeDesk);
      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.productlists-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

 
  return Productlists;
})();

//slick Product list
theme.Producttabs = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: '(min-width: 750px) and (max-width: 991px)',
    mediaQueryLarge: '(min-width: 992px) and (max-width: 1199px)',
    mediaQueryLargeDesk: 'screen and (min-width: 1200px)',
    slideShow: 0,
    scrollShow: 0,
    rowNumber: 0
  };
  var defaults = {
    accessibility: true,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 4,
    slidesToScroll: 4,
    rtl: checkrtl  
  };

  function Producttabs(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.producttabs-wrapper__item');
    $container.find('.producttabs-wrapper__item').children().each(function(){
      var blockid = $(this).attr('data-block-id');
      var slider = (this.slider = '#Producttabs-' + blockid);
      var $slider = $(slider, wrapper);
      config.slideShow = parseInt($slider.attr('data-toshow'));
      config.scrollShow = parseInt($slider.attr('data-scroll'));
      config.rowNumber = parseInt($slider.attr('data-row'));
      var play =       $slider.data('play');
      var checkplay =  $slider.data('autoplay');
      var arrows =     $slider.data('arrows');
      var dot =        $slider.data('dot');
      var laptop =     $slider.data('laptop');
      var table =     $slider.data('table');
      var phonemin =     $slider.data('phonemin');

      var sliderActive = false;
      var mobileOptions = $.extend({}, defaults, {
        arrows: arrows,
        dots:dot,
        slidesToShow: phonemin,
        slidesToScroll: phonemin,
        adaptiveHeight: true
      });
      var tableOptions = $.extend({}, defaults, {
        arrows: arrows,
        dots:dot,
        slidesToShow: table,
        slidesToScroll: table,
        adaptiveHeight: true
      });
      var desktopOptions = $.extend({}, defaults, {
        arrows: arrows,
        dots:dot,
        slidesToShow: laptop,
        slidesToScroll: laptop,
        adaptiveHeight: true
      });
      var desktopOptionsDesk = $.extend({}, defaults, {
        arrows: arrows,
        dots:dot,
        slidesToShow: config.slideShow,
        slidesToScroll: config.scrollShow,
        rows: config.rowNumber,
        adaptiveHeight: true,
        autoplay: checkplay,
        autoplaySpeed: play
      });

      enquire.register(config.mediaQuerySmall, {
        match: function() {
          initSlider($slider, mobileOptions);
        }
      });
      enquire.register(config.mediaQueryMediumUp, {
        match: function() {
          initSlider($slider, tableOptions);
        }
      });
      enquire.register(config.mediaQueryLarge, {
        match: function() {
          initSlider($slider, desktopOptions);
        }
      });
      enquire.register(config.mediaQueryLargeDesk, {
        match: function() {
          initSlider($slider, desktopOptionsDesk);
        }
      });

      function initSlider(sliderObj, args) {
        if (sliderActive) {
          sliderObj.slick('unslick');
          sliderActive = false;
        }

        sliderObj.slick(args);
        sliderActive = true;
      }
    });
  }
  return Producttabs;
})();

//slick Brand
theme.Brand = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: '(min-width: 750px) and (max-width: 991px)',
    mediaQueryLarge: '(min-width: 992px) and (max-width: 1199px)',
    mediaQueryLargeDesk: 'screen and (min-width: 1200px)',
    slideShow: 0,
    scrollShow: 0,
    rowNumber: 0
  };
  var defaults = {
    accessibility: true,
    dots: false,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 4,
    slidesToScroll: 4,
    rtl: checkrtl  
  };

  function Brand(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.brand-wrapper');
    var slider = (this.slider = '#Brand-' + sectionId);
    var $slider = $(slider, wrapper);
    config.slideShow = parseInt($slider.attr('data-toshow'));
    config.scrollShow = parseInt($slider.attr('data-scroll'));
    config.rowNumber = parseInt($slider.attr('data-row'));
    var play =       $slider.data('play');
    var checkplay =  $slider.data('autoplay');
    var arrows =     $slider.data('arrows');
    var dot =        $slider.data('dot');
    var laptop =     $slider.data('laptop');
    var table =     $slider.data('table');
    var phonemin =     $slider.data('phonemin');

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      arrows: arrows,
      dots:dot,
      slidesToShow: phonemin,
      slidesToScroll: phonemin,
      adaptiveHeight: true
    });
    var tableOptions = $.extend({}, defaults, {
      arrows: arrows,
      dots:dot,
      slidesToShow: table,
      slidesToScroll: table,
      adaptiveHeight: true
    });
    var desktopOptions = $.extend({}, defaults, {
      arrows: arrows,
      dots:dot,
      slidesToShow: laptop,
      slidesToScroll: laptop,
      adaptiveHeight: true
    });
    var desktopOptionsDesk = $.extend({}, defaults, {
      arrows: arrows,
      dots:dot,
      slidesToShow: config.slideShow,
      slidesToScroll: config.scrollShow,
      rows: config.rowNumber,
      adaptiveHeight: true,
      autoplay: checkplay,
      autoplaySpeed: play
    });

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });
    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, tableOptions);
      }
    });
    enquire.register(config.mediaQueryLarge, {
      match: function() {
        initSlider($slider, desktopOptions);
      }
    });
    enquire.register(config.mediaQueryLargeDesk, {
      match: function() {
        initSlider($slider, desktopOptionsDesk);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Brand.prototype = _.assignIn({}, Brand.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);
    enquire.unregister(config.mediaQueryLarge);
    enquire.unregister(config.mediaQueryLargeDesk);
      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.productlists-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Brand;
})();

//Banner masonry
theme.Banner = (function(){
// init Isotope
  function Banner(container){
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');
   var enable_3d =     $container.data('enable3d');
   var wrapper = this.wrapper = '.banner-wrapper';
   var slider = this.slider = '#Banner-' + sectionId;
   var project_anim = this.slider = '.project' + sectionId;
   var $pro = $(project_anim, wrapper);
   var $slider = $(slider, wrapper);
   var $grid = $slider.isotope({
        itemSelector: '.grid__item',
        percentPosition: true,
        masonry: {
          columnWidth: '.grid-sizer',
          isAnimated: true
        }
    });
    // layout Isotope after each image loads
    $grid.imagesLoaded().progress( function() {
        $grid.isotope('layout');
    });
    if(enable_3d == true){
        $pro.hover3d({
         selector: ".project__card",
         shine: true,
         sensitivity: 32,
       });
    }
  }
  
  return Banner;
})();


//Banner masonry
theme.Anim = (function(){
// init Isotope
  function Anim(container){
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');
   var wrapper = this.wrapper = '.anim-wrapper';
   var slider = this.slider = '#anim-' + sectionId;
   var $slider = $(slider, wrapper);
   var anim = (this.anim ='.grid__item-img-' + sectionId);
   // animation
     Array.from(document.querySelectorAll(anim)).forEach((el) => {
      const imgs = Array.from(el.querySelectorAll('img'));
      new hoverEffect({
        parent: el,
        intensity: el.dataset.intensity || undefined,
        speedIn: el.dataset.speedin || undefined,
        speedOut: el.dataset.speedout || undefined,
        easing: el.dataset.easing || undefined,
        hover: el.dataset.hover || undefined,
        image1: imgs[0].getAttribute('src'),
        image2: imgs[1].getAttribute('src'),
        displacementImage: el.dataset.displacement
      });
    });
  }
  
  return Anim;
})();

//Collections style 2
theme.Bgcollection = (function(){
// init Isotope
  function Bgcollection(container){
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');
   var wrapper = this.wrapper = '.bgcollection-wrapper';
   var slider = this.slider = '#Bgcollection-' + sectionId;
   var $slider = $(slider, wrapper);
   $(".colgrid__bg--full[data-index='1']").addClass('active');
   $('.colgrid .colgrid__box').each(function(){
         var index = $(this).attr("data-index");
         $(this).hover(
         function() {
            $(".colgrid__bg--full[data-index='"+index+"']").addClass('active');
         }, 
         function() {
               $(".colgrid__bg--full[data-index='"+index+"']").removeClass('active');
            }
         );
      });
    }
  
  return Bgcollection;
})();


theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
   var $container = this.$container = $(container);
   var sectionId = $container.attr('data-section-id');
   var slideshow =(this.slideshow = '#Slideshow-' + sectionId);

   $('.slideshow__video', slideshow).each(function() {
    var $el = $(this);
    theme.SlideshowVideo.init($el);
    theme.SlideshowVideo.loadVideo($el.attr('id'));
   });

   theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
  onUnload: function() {
   delete theme.slideshows[this.slideshow];
  },

  onBlockSelect: function(evt) {
   var $slideshow = $(this.slideshow);

   // Ignore the cloned version
   var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
   var slideIndex = $slide.data('slick-index');

   // Go to selected slide, pause autoplay
   $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
  },

  onBlockDeselect: function() {
   // Resume autoplay
   $(this.slideshow).slick('slickPlay');
  }
});

//instagram
theme.Instagrams = (function() {
  function Instagrams() {
  $('.instagram-block').each(function(){
    var instagram_clientId = $(this).attr('data-clientID');
    var instagram_get = $(this).attr('data-get'); 
    var instagram_tag = $(this).attr('data-tag'); 
    var instagram_locationId = $(this).attr('data-locationId'); 
    var instagram_limit = $(this).attr('data-limit'); 
    var instagram_resolution = $(this).attr('data-resolution');
    var instagram_accessToken = $(this).attr('data-accessToken');
    var instagram_userId = $(this).attr('data-userId');
    var instagram_arrows = $(this).attr('data-arrows');
    var instagram_dots = $(this).attr('data-dots');
    if( instagram_arrows == 'true'){
      var arrowTrue = true;
    }
    else{
      var arrowTrue = false;
    }
    if( instagram_dots == 'true'){
      var dotTrue = true;
    }
    else{
      var dotTrue = false;
    }
    var config = {
            mediaQuerySmall: 'screen and (max-width: 749px)',
            mediaQueryMediumUp: 'screen and (min-width: 750px)',
            slideShow: 0,
            scrollShow: 0,
            rowNumber: 0
          };
          var defaults = {
            accessibility: true,
            arrows: arrowTrue,
            dots: dotTrue,
            autoplay: false,
            touchThreshold: 20,
            slidesToShow: 4,
            slidesToScroll: 1,
            rtl: checkrtl  
          };
          var id = $(this).attr('data-slide-slick');
          var slider = '.slick-instagram-list-' + id;
          var wrapper = '.instafeed';
          var $slider = $(slider, wrapper);
          config.slideShow = parseInt($(this).attr('data-shortcode-column'));
          config.scrollShow = parseInt($(this).attr('data-shortcode-column'));
          config.rowNumber = parseInt($(this).attr('data-shortcode-row'));
          var sliderActive = false;
          var mobileOptions = $.extend({}, defaults, {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true
          });
          var desktopOptions = $.extend({}, defaults, {
            slidesToShow: config.slideShow,
            slidesToScroll: config.scrollShow,
            rows: config.rowNumber,
            adaptiveHeight: true
          });
    var feed = new Instafeed({
        clientId: instagram_clientId,
        accessToken:  instagram_accessToken,
        get: instagram_get,    
        userId: instagram_userId,
        limit: instagram_limit,
        resolution: instagram_resolution,
        target:"instafeed-" + id, 
        template: '<div class="grid__item"><a href="{{link}}" target="_blank"><img src="{{image}}" /><div class="content__insta likes text-center"><i class="fa fa-heart-o"></i> {{likes}} <i class="fa fa-commenting" style="margin-left: 15px"></i> {{comments}}</div></a></div>',
        after: function() {
          enquire.register(config.mediaQuerySmall, {
            match: function() {
              initSlider($slider, mobileOptions);
            }
          });

          enquire.register(config.mediaQueryMediumUp, {
            match: function() {
              initSlider($slider, desktopOptions);
            }
          });

          function initSlider(sliderObj, args) {
            if (sliderActive) {
              sliderObj.slick('unslick');
              sliderActive = false;
            }

            sliderObj.slick(args);
            sliderActive = true;
          }
          var images = $("#instafeed-" + id).find('a');
          $.each(images, function(index, image) {
            var delay = (index * 75) + 'ms';
            $(image).css('-webkit-animation-delay', delay);
            $(image).css('-moz-animation-delay', delay);
            $(image).css('-ms-animation-delay', delay);
            $(image).css('-o-animation-delay', delay);
            $(image).css('animation-delay', delay);
            $(image).addClass('animated fadeIn');
          });
        }
    });
    feed.run();
  });
  }
  return Instagrams;
})();

//Countdown
theme.Countdown = (function() {
  function Countdown(container) {
    var $container = this.$container = $(container);
     var sectionId = $container.attr('data-section-id');
     var wrapper = this.wrapper = '.count-wrapper';
     var play = this.play = '#Count-' + sectionId;
     var $play = $(play, wrapper);
      var getdeal =     $play.data('deals');
     var $countdown = $play.lofCountDown({
        TargetDate:getdeal,
        DisplayFormat:"<ul class='list-inline'><li class='day'>%%D%%<span>Days</span></li><li>%%H%%<span>Hours</span></li><li>%%M%%<span>Mins</span></li><li>%%S%%<span>Secs</span></li></ul>",
        FinishMessage: "End Deal"
    });
  }
  return Countdown;
})();


$(document).ready(function() {
    var a = new theme.Sections;
    a.register("cart-template", theme.Cart), 
    a.register("product", theme.Product), 
    a.register("collection-template", theme.Filters), 
    a.register("product-template", theme.Product), 
    a.register("header-section", theme.HeaderSection), 
    a.register("map", theme.Maps), 
    a.register("slideshow-section", theme.SlideshowSection), 
    a.register("quotes", theme.Quotes), 
    a.register("look", theme.Look), 
    a.register("lookhome", theme.Lookhome), 
    a.register("list", theme.List), 
    a.register("blogs", theme.Blogs),
    a.register('productlists', theme.Productlists),
    a.register('producttabs', theme.Producttabs),
    a.register('brand', theme.Brand),
    a.register('look2', theme.Look2),
    a.register('banner', theme.Banner),
    a.register('bgcollection', theme.Bgcollection),
    a.register('instagrams', theme.Instagrams),
    a.register('countdown', theme.Countdown),
    a.register('anim', theme.Anim)
    
    
});
theme.init = function() {
    theme.customerTemplates.init(), slate.rte.wrapTable(), slate.rte.iframeReset(), slate.a11y.pageLinkFocus($(window.location.hash)), $(".in-page-link").on("click", function(a) {
        slate.a11y.pageLinkFocus($(a.currentTarget.hash))
    }), $('a[href="#"]').on("click", function(a) {
        a.preventDefault()
    })
};





